import React from "react";
import Card from "components/card";
import { Heart, Laptop} from "lucide-react";

const NoTickets = ({ variant = 'it-support' }) => {
    
    // Choose icon based on variant
    const Icon = variant === 'hr-support' ? Heart : Laptop;

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-dashed border-slate-300 dark-mode-card">
            <div className="px-6 pb-6 flex flex-col items-center justify-center py-12 text-center">
                <Icon className="w-16 h-16 mb-4 opacity-50 muted-text" />
                <h4 className="text-[16px] font-semibold mb-2 title-text">
                    No Tickets Found
                </h4>
                <p className="text-[13px] max-w-sm muted-text">
                    Try adjusting your search or filters
                </p>
            </div>
        </Card>
    )
};

export default NoTickets;